import { Link } from "react-router-dom";

export default function WebinarFooter() {
  return (
    <footer className="bg-alt-bg border-t border-gray-200 py-10 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex flex-col sm:flex-row items-center gap-6">
          <Link to="/" className="text-navy font-extrabold text-lg tracking-tight whitespace-nowrap">
            IMPERIUM
          </Link>
          <div className="flex items-center flex-wrap gap-3">
            {[
              { icon: "ri-shield-check-line", text: "SOC 2 Type II" },
              { icon: "ri-scales-3-line", text: "TCPA Compliant" },
              { icon: "ri-lock-line", text: "Secure by Default" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-primary text-xs`} />
                </span>
                <span className="text-xs font-medium text-[#4a5568] whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-5">
          <Link to="/" className="text-xs text-[#4a5568] hover:text-navy transition-colors whitespace-nowrap">
            ← Back to Main Site
          </Link>
          <p className="text-xs text-[#4a5568]">
            &copy; {new Date().getFullYear()} Imperium. All rights reserved.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-6 pt-6 border-t border-gray-200">
        <p className="text-[11px] text-gray-400 leading-relaxed text-center max-w-3xl mx-auto">
          Imperium provides AI-powered outbound calling infrastructure for title companies. All call examples shown are illustrative. Results vary based on market conditions, agent responsiveness, and usage. This webinar does not constitute a guarantee of any specific outcome.
        </p>
      </div>
    </footer>
  );
}
